import { useEffect, useState } from "react"
import { Wrapper, Header, TextsSection, HeadingColor, Topic, Frame, FrameHeading, SentenceWrapper, DialogName, DialogLine, Correct, DialogWrapper } from "./DialogsStyle"
import { DialogsData } from "./DialogsData"
import Topics from "../04_topics/Topics"
import { TopicData } from "../04_topics/TopicsData"
import useInstantScroll from "../../../hooks/useInstalntScroll"
import ToTheTop from "../../../components/04_common/02_tothetop/ToTheTop"
import { useSelector } from "react-redux"
import { speaking } from "../../../i18n/09_speaking"


const Dialogs = () => {
    const lang = useSelector(state => state.lang.lang)
    const t = speaking[lang]

    const [dialogData, setDialogData] = useState(DialogsData)

    const [isGuest, setIsGuest] = useState(false)

    const { lessons } = useSelector(state => state.studentLessons)

    const { jumpToHash } = useInstantScroll();

    const role = useSelector((s) => s.auth?.user?.role); // ✅ add
    const isPrivileged = role === "TEACHER" || role === "ADMIN"; // ✅ add

    const isLessonUnlocked = (lessonNumber) => {
        // ✅ TEACHER/ADMIN: show everything
        if (isPrivileged) return true;
        if (!lessons || lessons.length === 0) {
            return lessonNumber === 0
        }
        const lesson = lessons.find((l) => l.order === lessonNumber)
        return !!lesson?.isUnlocked
    }

    const clickLesson = (lessonNumber) => {
        if (!isLessonUnlocked(lessonNumber)) return
        jumpToHash(`#lesson-${lessonNumber}`)
    }

    const clickQuestion = (mainIndex, index) => {

        setDialogData(prev =>
            prev.map((firstValue, firstIndex) =>
                firstIndex === mainIndex ?
                    {
                        ...firstValue,
                        dialog: firstValue.dialog.map((secondValue, secondIndex) =>
                            secondIndex === index ? {
                                ...secondValue,
                                q_display: secondValue.q_display === "block" ? "none" : "block"
                            } : secondValue
                        )
                    }
                    : firstValue
            )
        )
    }


    const clickAnswer = (mainIndex, index) => {
        setDialogData(prev =>
            prev.map((firstValue, firstIndex) =>
                firstIndex === mainIndex ?
                    {
                        ...firstValue,
                        dialog: firstValue.dialog.map((secondValue, secondIndex) =>
                            secondIndex === index ?
                                {
                                    ...secondValue,
                                    a_display: secondValue.a_display === "block" ? "none" : "block"
                                } : secondValue
                        )
                    }
                    : firstValue
            )
        )
    }


    // const handleTopicClick = (index) => {

    //     jumpToHash(`#lesson-${index + 1}`)
    // }

    useEffect(() => {
        setIsGuest(!lessons || lessons.length === 0);
    }, [lessons]);

    return (

        <Wrapper>
            <Header
                onClick={clickQuestion}
            >
                {t.dialogsHeader}
            </Header>
            <Topics
                isGuest={isGuest}
                isLessonUnlocked={isLessonUnlocked}
                clickLesson={clickLesson}
            />

            {dialogData.map((mainValue, mainIndex) => {

                const lessonNumber = mainIndex + 1

                if (!isLessonUnlocked(lessonNumber)) {
                    return null
                }

                return (
                    <TextsSection
                        key={mainIndex}
                        id={`lesson-${lessonNumber}`}
                    >
                        <Frame>
                            <HeadingColor>
                                Lesson {lessonNumber}
                                <Topic>
                                    {TopicData[mainIndex].topic}
                                </Topic>
                            </HeadingColor>
                            {mainValue.dialog.map((value, index) => (
                                <DialogWrapper key={index}>

                                    <SentenceWrapper>
                                        <DialogName>
                                            Person 1:  &nbsp;
                                        </DialogName>
                                        <DialogLine id={index} onClick={() => clickQuestion(mainIndex, index)}>
                                            {value.question} &nbsp;
                                        </DialogLine>
                                        <Correct style={{ display: value.q_display }}>
                                            {value.q_translate}
                                        </Correct>
                                    </SentenceWrapper>

                                    <SentenceWrapper>
                                        <DialogName>
                                            Person 2:  &nbsp;
                                        </DialogName>
                                        <DialogLine id={index} onClick={() => clickAnswer(mainIndex, index)}>
                                            {value.answer} &nbsp;
                                        </DialogLine>
                                        <Correct style={{ display: value.a_display }}>
                                            {value.a_translate}
                                        </Correct>
                                    </SentenceWrapper>
                                </DialogWrapper>
                            ))}
                        </Frame>
                    </TextsSection>
                )
            })}
            <ToTheTop />
        </Wrapper>
    )
}

export default Dialogs